<template>
  <div class="blogPage">
    <div class="container">
      <h1 class="center-header mx-auto text-center center-header__title">Blogs</h1>

      <div class="text-end">
        <button @click="goToAuth" class="add-blog-btn">Add Blog</button>
      </div>

      <div class="blogPage__list">
        <div
          v-for="blog in blogData"
          :key="blog.id"
          class="blogPage__box"
        >
          <div class="blogPage__imgbox">
            <img
              v-if="blog.image1 && isImageUrl(blog.image1)"
              :src="blog.image1"
              alt="Blog media"
              class="blogPage__img"
            />
            <video
              v-else-if="blog.image1 && isVideoUrl(blog.image1)"
              :src="blog.image1"
              class="blogPage__img"
              controls
            />
            <p v-else>Unsupported media format</p>
          </div>

          <div class="blogPage__details">
            <p class="blogPage__tags">
              <span
                v-for="(tag, index) in blog.tags.split(',')"
                :key="index"
                class="blue mx-2"
              >{{ tag.trim() }}</span>
            </p>

            <h3 class="blogPage__title">{{ blog.title }}</h3>
            <p class="blogPage__author">
              By
              <a :href="blog.authorLink" class="blue">{{ blog.author }}</a>
              on {{ blog.date }}
            </p>

            <div class="blogPage__introduction" v-html="blog.introduction"></div>

            <div class="text-end">
              <router-link :to="`/blog/${blog.id}`" class="blue">Read more</router-link>
            </div>
          </div>
        </div>
      </div>

      <div class="testimonial">
        <TestimonialCarousel />
      </div>

      <div class="getInTouch">
        <GetInTouch />
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { getDatabase, ref as dbRef, get } from 'firebase/database';
import { app } from '@/firebase/firebase';
import TestimonialCarousel from '@/components/TestimonialCarousel.vue';
import GetInTouch from '@/components/GetInTouch.vue';
import { useRouter } from 'vue-router';

export default {
  name: 'BlogPage',
  components: {
    TestimonialCarousel,
    GetInTouch,
  },
  setup() {
    const blogData = ref([]);
    const db = getDatabase(app);
    const router = useRouter();

    const fetchAllBlogs = async () => {
      try {
        const blogsRef = dbRef(db, 'blogs');
        const snapshot = await get(blogsRef);
        if (snapshot.exists()) {
          const blogsList = [];
          snapshot.forEach((childSnapshot) => {
            const blog = childSnapshot.val();
            blogsList.push({
              id: childSnapshot.key,
              ...blog,
            });
          });
          blogsList.sort((a, b) => new Date(b.date) - new Date(a.date));
          blogData.value = blogsList;
        }
      } catch (error) {
        console.error('Error fetching blogs:', error);
      }
    };

    const isImageUrl = (url) => /\.(jpeg|jpg|gif|png|webp)$/i.test(url);
    const isVideoUrl = (url) =>
      /\.(mp4|webm|ogg)$/i.test(url) || url.includes('youtube') || url.includes('vimeo');

    const goToAuth = () => {
      router.push('/auth');
    };

    onMounted(() => {
      fetchAllBlogs();
      window.scrollTo(0, 0);
    });

    return {
      blogData,
      isImageUrl,
      isVideoUrl,
      goToAuth,
    };
  },
};
</script>

<style scoped>
.blogPage {
  padding: 40px 0;
}

.container {
  padding: 0 15px;
}

.center-header__title {
  font-size: 2.5rem;
  margin-top: 50px;
  margin-bottom: 20px;
}


.blogPage__list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  margin-top: 30px;
}

@media (max-width: 1200px) {
  .blogPage__list {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .blogPage__list {
    grid-template-columns: 1fr;
  }
}

.blogPage__box {
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease-in-out;
}

.blogPage__imgbox {
  width: 100%;
  height: 220px;
  overflow: hidden;
}

.blogPage__imgbox img,
.blogPage__imgbox video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.blogPage__imgbox:hover img,
.blogPage__imgbox:hover video {
  transform: scale(1.05);
}

.blogPage__details {
  padding: 15px;
}

.blogPage__tags span {
  font-size: 12px;
  color: #007bff;
}

.blogPage__title {
  font-size: 1.4rem;
  font-weight: bold;
  margin: 10px 0;
}

.blogPage__author {
  font-size: 13px;
  color: #555;
  margin-bottom: 10px;
}

.blogPage__author a {
  color: #007bff;
}

.blogPage__introduction {
  font-size: 14px;
  color: #333;
  margin-bottom: 10px;
}

.text-end a {
  font-size: 14px;
  color: #007bff;
}

.add-blog-btn {
  background-color: #007bff;
  color: white;
  padding: 10px 20px;
  font-size: 14px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.add-blog-btn:hover {
  background-color: #0056b3;
}

.testimonial,
.getInTouch {
  margin-top: 40px;
}
</style>
